import React from "react";

import { FavoriteButton } from "@/components/ui/favorite-button/FavoriteButton";
import {
  LadyDtoToggleMediaFavorite,
  useFavorite,
} from "@/features/lady-profile/hooks";

type PropTypes = {
  isFavorite?: boolean;
  objectId?: number;
  toggleMediaFavorite?: LadyDtoToggleMediaFavorite;
  favoriteType: Parameters<typeof useFavorite>["0"]["favoriteType"];
};

export const FavoriteButtonController: React.FC<PropTypes> = ({
  isFavorite = false,
  favoriteType,
  objectId,
  toggleMediaFavorite,
}) => {
  const { onFavouriteClick } = useFavorite({
    favoriteType,
    isFavorite,
    objectId,
  });

  const handleFavoriteClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (objectId && toggleMediaFavorite) {
      toggleMediaFavorite({
        objectId,
        mediaType: favoriteType === "PHOTO" ? "photo" : "video",
      });
    }

    onFavouriteClick(event);
  };

  const mediaTypeForLabel = favoriteType === "PHOTO" ? "photo" : "video";
  const favoriteButtonAriaLabel = `${
    isFavorite
      ? `Remove ${mediaTypeForLabel} from favorite`
      : `Add ${mediaTypeForLabel} to favorite`
  }`;

  return (
    <FavoriteButton
      onClick={handleFavoriteClick}
      isFavorite={isFavorite}
      ariaLabel={favoriteButtonAriaLabel}
    />
  );
};
